import config from '@/config'

const { assetResourceHost } = config
const accountantExportUrl = `${config.resourceHost}accountantExport/`
const settingUrl = `${config.resourceHost}setting/`

export const jumpMarkLinks = {
  userData: 'userData',
  support: 'support',
  abos: 'abos',
  abosInfo: 'abosInfo',
  email: 'email',
  tenantLogo: 'tenantLogo',
  tenantLogoTaxConsultant: 'tenantLogoTaxConsultant',
  emailAttachmentDocument: 'emailAttachmentDocument',
  contactData: 'contactData',
  tax: 'tax',
  bookkeeping: 'bookkeeping',
  numeration: 'numeration',
  layout: 'layout',
  letterPaper: 'letterPaper',
  logo: 'logo',
  customerLogo: 'customerLogo',
  contactInfo: 'contactInfo',
  paymentProviders: 'paymentProviders',
  documentsUpload: 'documentsUpload',
  eSigning: 'eSigning',
  webshops: 'webshops',
  shipping: 'shipping',
  paymentAndDeliveryConditions: 'paymentAndDeliveryConditions',
  textModules: 'textModules',
  dunning: 'dunning',
  titleAndUnits: 'titleAndUnits',
  dataTransfer: 'dataTransfer',
  transactionProcessing: 'transactionProcessing',
  documentExport: 'documentExport',
  menuSettings: 'menuSettings',
  eventLog: 'eventLog',
  eInvoice: 'eInvoice',
  mailbox: 'mailbox',
  xInvoice: 'xInvoice',
  creditorIdentifier: 'creditorIdentifier',
  tenantExport: 'tenantExport',
  transactionCreation: 'transactionCreation',
  aiSettings: 'aiSettings',
}

export default {
  assetResourceHost,

  clientUrl: {
    multiple: 'settings/document-export',
  },

  constants: {
    NUMERATION_NO_DATE: 'none',
    NUMERATION_YEARLY: 'YYYY',
    NUMERATION_MONTHLY: 'YYYYMM',
    NUMERATION_DAILY: 'YYYYMMDD',
  },

  dateFormats: {
    year: 'YYYY',
    yearMonth: 'YYYYMM',
    yearMonthDay: 'YYYYMMDD',
  },

  billingFormFields: [
    'firstName',
    'lastName',
    'street',
    'zipCode',
    'city',
    'bankAccountHolder',
    'bankAccountIBAN',
    'sepaMandate',
    'companyName',
    'countryIso',
    'vatNumber',
  ],

  infoSettings: `${config.resourceHost}InfoSetting`,

  // settings
  offerSettings: `${settingUrl}offer`,
  orderSettings: `${settingUrl}order`,
  purchaseSettings: `${settingUrl}purchase`,
  invoiceSettings: `${settingUrl}invoice`,
  depositInvoiceSettings: `${settingUrl}depositinvoice`,
  partialInvoiceSettings: `${settingUrl}partialinvoice`,
  deliveryNoteSettings: `${settingUrl}deliverynote`,
  cancellationSettings: `${settingUrl}cancellation`,
  creditNoteSettings: `${settingUrl}creditnote`,
  taxAccountantSettings: `${settingUrl}taxAccountant`,
  taxAccountantAccess: `${settingUrl}taxAccountantAccess`,
  eventLog: `${settingUrl}eventLog`,
  letterSettings: `${settingUrl}letter`,
  tenantUserSettings: `${settingUrl}tenantUser`,

  // tenant informations endpoint
  getTenantInfo: `${config.resourceHost}tenant`,
  getTenantSetting: `${config.resourceHost}tenant/setting`,
  getUserInfo: `${config.resourceHost}user/self`,
  upsertDemoTenant: `${config.resourceHost}tenant/upsertdemotenant`,
  updateVatRate: `${config.resourceHost}tenant/vatRate`,
  updateTenantSkrType: `${config.resourceHost}tenant/skrType`,
  refreshToken: `${config.resourceHost}auth/refreshToken`,

  // subscription endpoints
  getSubscriptionTypeModules: (subscriptionType) => `${config.resourceHost}subscription/${subscriptionType}/modules`,
  getSubscriptionDetails: `${config.resourceHost}subscription/detail`,
  subscription: `${config.resourceHost}subscription`,
  getSubscriptionBillingData: (subscriptionId) => `${config.resourceHost}subscription/${subscriptionId}/billingData`,
  getOrSetDanglingSubscriptions: `${config.resourceHost}subscription/dangling`,
  cloneTicketForBuhlMarketplace: `${config.resourceHost}auth/buhlkonto/cloneTicket?target=marketplace`,

  // module endpoints
  subscriptionModule: `${config.resourceHost}subscription/module`,
  getSubscriptionModules: `${config.resourceHost}subscription/modules`,

  // account endpoint
  account: `${settingUrl}account`,
  clientAccount: `${settingUrl}clientAccount`,
  user: `${config.resourceHost}user`,
  notification: `${settingUrl}notification`,
  privacyConsentStatus: `${settingUrl}privacyConsentStatus`,
  privacyConsentHistory: `${settingUrl}privacyConsentHistory`,
  pbbLogActive: `${settingUrl}pbbLogActive`,
  letterPaperPages: `${settingUrl}letterpaper/pages`,

  // paypal endpoint
  createPaypalSignUpLink: `${config.resourceHost}pay/paypal/signuplink`,
  paypalMerchantonboarded: `${config.resourceHost}pay/paypal/merchantonboarded`,
  paypalShowPaypalAdLater: `${config.resourceHost}pay/paypal/showPaypalAdLater`,
  getPaypalAccount: `${config.resourceHost}pay/paypal/account`,

  // stripe endpoint
  createStripeSignUpLink: `${config.resourceHost}pay/stripe/signuplink`,
  getStripeAccount: `${config.resourceHost}pay/stripe/account`,

  // email settings endpoints
  emailAccountsList: `${settingUrl}email/list`,
  emailServiceStatus: `${settingUrl}email`,
  emailServiceSetup: `${settingUrl}email/setup`,
  emailAccountAsDefault: `${settingUrl}email/default`,
  getEmailSignature: `${settingUrl}email/signature`,
  setEmailSignature: `${settingUrl}email/signatures`,

  deleteEmailAccount: `${settingUrl}email/delete`,
  createEmailAccount: `${settingUrl}email/create`,
  updateEmailAccount: `${settingUrl}email/update`,
  getEmailAccountSettings: `${settingUrl}email/account`,
  getEmailServiceSetup: `${settingUrl}email/status`,
  getSystemEmail: `${config.resourceHost}email/system`,
  setAccountAsDefault: `${settingUrl}email/default`,
  deleteEmailAccountEmails: `${config.resourceHost}email/account`,
  deleteEmail: `${config.resourceHost}email`,
  getEmailOAuthConfig: `${settingUrl}email/config`,

  // attachment settings endpoints
  attachmentSettings: `${settingUrl}attachments`,

  // attachment documents settings endpoints

  attachmentDocumentsList: `${config.resourceHost}email/emailAttachmentDocuments`,

  // condition endpoints
  payConditions: `${settingUrl}payCondition`,
  deliveryConditions: `${settingUrl}deliveryCondition`,

  // paykinds endpoints
  payKinds: `${settingUrl}payKind`,

  // ecommerce endpoints
  ecommerce: `${config.resourceHost}shop-connector/shop`,

  // extension endpoints
  extensions: `${settingUrl}extension`,

  // tenant export endpoints
  tenantExport: `${config.resourceHost}tenant/export`,

  tenantExportUrl: (exportId) => `${config.resourceHost}tenant/export/${exportId}/url`,

  // shipping endpoints
  shipping: `${config.resourceHost}shipping`,

  // shipment types endpoint
  shipmentType: `${config.resourceHost}shipmentType`,

  // company
  companySettingsUrl: '/settings/mycompany',

  // bookkeeping
  bookkeepingRecreateUrl: `${settingUrl}recreate`,

  // tag endpoints
  miscellaneousData: `${settingUrl}miscellaneous`,
  activityAll: `${settingUrl}activityCategoryAll`,
  contact: `${settingUrl}contact`,
  article: `${settingUrl}article`,
  customer: `${settingUrl}customer`,
  activity: `${settingUrl}activity`,
  hourlyRate: `${settingUrl}hourlyRate`,
  getCustomerCategory: `${config.resourceHost}customer/findByCategory`,
  replaceCustomerCategory: `${config.resourceHost}customer/renameCategory`,
  getArticleUnits: `${config.resourceHost}article/findByUnit`,
  replaceArticleUnit: `${config.resourceHost}article/renameUnit`,
  getArticleCategory: `${config.resourceHost}article/findByCategory`,
  replaceArticleCategory: `${config.resourceHost}article/renameCategory`,

  // letterPaper endpoints
  createLetterPaper: `${config.resourceHost}setting/letterPaper`,
  getLetterPaper: `${config.resourceHost}setting/letterPaper`,
  getLetterPaperLayout: `${config.resourceHost}setting/letterPaper/layouts`,

  // text module endpoints
  textModule: `${settingUrl}textModule`,
  textModules: `${settingUrl}textModules`,

  // dunning endpoints
  dunningLevel: `${settingUrl}dunningLevel`,

  // dunning endpoints
  emailSettings: `${settingUrl}email`,

  // eInvoice endpoints
  generateEInvoiceActive: `${config.resourceHost}tenant/setting/generateEInvoiceActive`,

  getEmailsOfDocumentExports: 'cachedata/getemailsofaccountantexports',

  getNumerationSettings: `${config.resourceHost}setting/numeration`,
  updateInvoiceNumeration: `${config.resourceHost}setting/invoice/changeNumeration`,
  updateOfferNumeration: `${config.resourceHost}setting/offer/changeNumeration`,
  updateDeliveryNoteNumeration: `${config.resourceHost}setting/deliverynote/changeNumeration`,
  updateOrderNumeration: `${config.resourceHost}setting/order/changeNumeration`,
  updatePurchaseNumeration: `${config.resourceHost}setting/purchase/changeNumeration`,

  deleteTenantUrl: `${config.resourceHost}tenant`,
  tenantRolesUrl: `${config.resourceHost}tenant/role`,

  cancelSubscriptionUrl: (id) => `${config.resourceHost}subscription/${id}/cancel`,
  cancelModuleSubscriptionUrlByName: (name) => `${config.resourceHost}subscription/module/${name}`,

  // customer center
  getCustomerCenterSettings: `${settingUrl}customer-center`,
  updateCustomerCenterContactInfo: `${settingUrl}customer-center/contact-info`,
  updateCustomerCenterAutoEnablePaymentProvider: `${settingUrl}customer-center/auto-enable-payment-provider`,
  updateCustomerCenterGamificationCompleted: `${settingUrl}customer-center/gamification-completed`,
  getCustomerCenterDocumentsList: `${settingUrl}customer-center/documents`,
  fetchCustomerCenterDocument: `${settingUrl}customer-center/document`,
  putCustomerCenterESignature: `${settingUrl}customer-center/e-signature`,

  // tax consultant
  getTaxConsultant: `${config.resourceHost}tenantCollaborations/getTaxTenant`,
  inviteTaxConsultant: `${config.resourceHost}tenantCollaborations/inviteTaxTenant`,
  searchTaxConsultant: `${config.resourceHost}tenantCollaborations/searchTaxConsultant`,
  setConnectionStatus: `${config.resourceHost}tenantCollaborations/setConnectionStatus`,
  resendCollaborationInvitation: `${config.resourceHost}tenantCollaborations/resendCollaborationInvitation`,
  disconnectTaxConsultant: `${config.resourceHost}tenantCollaborations/disconnectTaxTenant`,
  restoreCollaboration: `${config.resourceHost}tenantCollaborations/restoreCollaboration`,
  getInvitingTenants: `${config.resourceHost}tenantCollaborations/getInvitingTenants`,

  accountantExportUrl,
  documentExportOptions: {
    list: {
      pagination: {
        page: 1,
        pageSize: 10,
      },
      defaultSort: {
        property: 'createdAt',
        desc: true,
      },
    },
  },
  emailSettingStates: {
    LOADING: 'loading',
    EDIT: 'edit',
    ERROR: 'error',
    CONNECTED: 'connected',
    DELETE: 'delete',
    CONNECTING: 'connecting',
    CLOSED: 'closed',
  },
  initOutgoingEmailSettings: {
    email: '',
    password: '',
    host: '',
    userName: '',
    port: 'auto',
    secure: false,
    isDefault: false,
    id: null,
    senderName: '',
  },
  initIncommingEmailSettings: {
    email: '',
    password: '',
    imapServer: '',
    imapUserName: '',
    imapPort: 'auto',
    isDefault: false,
    id: null,
  },
}
